import { css } from '@emotion/react'
import { Button, Heading, HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { PageContainer } from 'components/layout/PageContainer'
import { ReactComponent as AvisoCidadaoCdsIcon } from 'images/cidadao/aviso-cidadao-cds.svg'
import { useState } from 'react'

import { ModalNovidadesAcompanhamentoTerritorio } from './ModalNovidadesAcompanhamentoTerritorio'

export function AlertNovidadesAcompanhamentoTerritorio() {
  const theme = useTheme()
  const styles = createStyles(theme)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const handleClose = () => setIsModalOpen(false)
  const handleOpen = () => setIsModalOpen(true)

  return (
    <PageContainer>
      <ModalNovidadesAcompanhamentoTerritorio isModalOpen={isModalOpen} onClose={handleClose} />
      <HFlow justifyContent='center'>
        <HFlow hSpacing={1} alignItems='center' justifyContent='center' style={styles.container}>
          <AvisoCidadaoCdsIcon css={styles.img} />
          <VFlow>
            <VFlow vSpacing={0.2} style={styles.text}>
              <Heading level={3}>
                O cadastro domiciliar e territorial está com uma estrutura mais clara e completa!
              </Heading>
              <Text>
                Para iniciar um novo cadastro domiciliar e territorial acesse a funcionalidade de acompanhamento de
                território no menu lateral.
              </Text>
            </VFlow>

            <Button onClick={handleOpen} skin='outline' kind='primary' size='small'>
              Saiba mais
            </Button>
          </VFlow>
        </HFlow>
      </HFlow>
    </PageContainer>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    padding: 0.75rem 1.5rem;
    outline: 1px solid ${theme.pallete.gray.c60};
    background-color: ${theme.pallete.surface.main};
    border-radius: 0.4rem;
    min-height: 150px;
    width: 60rem;
    max-width: 100%;
  `,
  text: css`
    max-width: 55rem;
  `,
  img: css`
    align-self: flex-end;
    margin-bottom: -0.75rem;
  `,
})
